import heroImg from "../../assets/mainItems/heroImg.png";

import "./HeroImg.css";

const HeroImg = (params) => {
  return (
    <div className="heroimg-wrapper">
      <div className="heroimg-title-wrapper">
        <h1>Welcome to All In One Hub</h1>
        <h2>A World of Taste Under One Roof</h2>
      </div>
      <div className="heroimg-image-wrapper">
        <img src={heroImg} alt="Banner" className="heroimg-image" />
      </div>
    </div>
  );
};

export default HeroImg;
